import React from 'react';
import PaymentTracker from '../views/PaymentTracker';
import PaymentTrackerDetailsView from '../views/PaymentTrackerDetailsView';
import { Route, Routes } from 'react-router-dom';

function AppRouter() {
    return (
        <Routes>
            <Route path="/" exact element={<PaymentTracker />} />
        </Routes>
    );
}
export default AppRouter;
